export default class EDDataset {

    add(pName, pValue) {
        if(typeof pValue != "undefined") {
            this._dataset.set(pName, pValue)

            if(this._parent._DOMElement) {
                this._parent._DOMElement.dataset[pName] = pValue
            }
        }
    }

    has(pName) {
        return this._dataset.has(pName)
    }

    get(pName) {
        return this._dataset.get(pName)
    }

    remove(pName) {

        this._dataset.delete(pName)

        if(this._parent._DOMElement) {
            delete this._parent._DOMElement.dataset[pName]
        }
    }

    render() {

        this._dataset.forEach((value, name) => {
            this._parent._DOMElement.dataset[name] = value
        })
    }

    getDOMId() {
        return this.get("eddomid")
    }

    constructor(pParent, pDataset) {

        this._parent = pParent
        this._dataset = new Map()

        if(
            pDataset 
            && typeof pDataset === 'object' 
            && pDataset !== null
        ) {

            Object.entries(pDataset).forEach(([name, value]) => {
                this.add(name, value)
            })
        }

    }

}